import React from "react";
import "./AboutUs.css"; // Assuming your CSS file is still used
import Features from "../Features";
import { chooseTie, tieFeatures } from "../../utils/aboutus";
import WeOffer from "../WeOffer";
import img from "../../Images/blogimg.png"

const AboutUs = () => {
  return (
    <div>
      <div className="about-us-container">
        <h1 className="section-title">Tech It Easy
        </h1>
        <div className="about-us-content">
          <p>
          Simplifying Technology for Businesses
          </p>
        </div>
      </div>
      <div className="about-tie">
          <h2>How <span>Tech It Easy</span> Came Into Being </h2>
          <div className="about-tie-content">
          <div className="about-image-container">
            <img src={img} alt="about-image"/>
          </div>
         <div className="about-tie-desc">
         <p>Tech It Easy, established in 2020, is a leading software development company specializing in transportation management solutions and custom software development. In less than five years, we have proudly associated with 100+ satisfied clients, delivering smart, automated, and efficient technology solutions that help businesses streamline operations, enhance compliance, and improve productivity.</p>
          <p>Our flagship products, Saral Transport and Saral Way, have transformed the logistics industry. Beyond transportation software, we offer custom software development, IoT solutions, mobile & web app development, DevOps, and application modernization for businesses across various industries.
          </p>
          <p>We make technology simple, scalable, and efficient, enabling businesses to automate processes, reduce costs, and stay ahead in a digital world.
          </p>

          <p>At Tech It Easy, we believe in building strong partnerships and helping businesses grow with the right technology. Whether you're looking for a robust transportation management system, a cutting-edge software solution, or digital transformation services, we are here to turn your vision into reality.
          </p>
         </div>

          </div>
        </div>
      <Features features={tieFeatures}/>
      <WeOffer data={chooseTie}/>
    </div>
  );
};

export default AboutUs;
